import { OrangeCrmPlugin } from "../orange_crm/orangeCrmPlugin";

export class OrangeCrmOmniPlugin extends OrangeCrmPlugin {
  public readonly id = "orange_crm_omni";
}
